import http from "../httpService";
import { DateTime } from "luxon";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/accounting-journal/";

export function getAccountingHeadJournal(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `accounting-head/${dateFrom}/${dateTo}`);
}

export function saveAccountingJournal(accountingJournal) {
  return http.post(apiEndpoint, accountingJournal);
}

export function getAccountingJournalDetail(journalID = 0) {
  return http.get(apiEndpoint + "accounting-detail/" + journalID);
}

export function reverseAccountingJournal(journalID = 0) {
  return http.delete(apiEndpoint + "reverse-accounting-journal/" + journalID);
}
